<template>
  <div>
    <template v-if="this.state != null && this.dataPieCharts != null && this.dataPPDS != null">
      <template v-if="this.user.roles[0] != 'EC_USER'">
        <template v-if="$vuetify.breakpoint.mdAndUp">
          <BottomNavigationControl :mppt="state.mppt" :dab="state.battery.batteries" />
        </template>

        <template v-if="$vuetify.breakpoint.smAndDown">
          <BottomNavigationControl :mppt="state.mppt" :dab="state.battery.batteries" :panel="false" />
        </template>
      </template>

      <v-row>
        <v-col :cols="$vuetify.breakpoint.md === true ? 12 : ''" :md="$vuetify.breakpoint.md === true ? 6 : ''">
          <CardUnit
            :cardMaxWidth="cardMaxWidth"
            :cardName="$t('home.output.name')"
            unitName="Output"
            topRightText="Consumption"
            :topRightValue="Math.abs(state.load.power) > 0 ? 1 : 0"
            :statusValue="statusConsumption.toString()"
            :statusText="shortStatusConsumption.toString()"
            :powerValue="state.load.power"
            energyText
            energyValue
            :energyHeader1="$t('home.output.today')"
            :energyHeader2="$t('home.output.yesterday')"
            :energy1Text="$t('home.output.consumed')"
            :energy1Value="state.load.energyToday"
            :energy3Text="$t('home.output.consumed')"
            :energy3Value="state.load.energyYesterday"
            :value4Text="state.load.power != 0 ? $t('home.output.desc1') : $t('home.output.desc2')"
            :gaugeColor="gaugeColorLoad"
            :gaugeValue="state.load.power"
          ></CardUnit>
        </v-col>

        <v-col :cols="$vuetify.breakpoint.md === true ? 12 : ''" :md="$vuetify.breakpoint.md === true ? 6 : ''">
          <CardUnit
            :cardMaxWidth="cardMaxWidth"
            :cardName="$t('home.inverter.name')"
            unitName="Inverter"
            :stateValue="state.inverter.state != '' ? $t('variableValues.state.' + state.inverter.state.replace('ERR_', '')) : ''"
            :stateText="$t('home.output.state')"
            :stateTooltip="state.inverter.state"
            stateValue2=""
            stateText2=""
            stateTooltip2=""
            topRightText="Relay"
            :topRightValue="relayInverterConnected"
            :statusValue="statusInverter.toString()"
            :statusText="shortStatusInverter.toString()"
            :errorValue="state.inverter.error1 != '' ? $t('variableValues.error.' + state.inverter.error1) : ''"
            :errorText="$t('home.output.error')"
            :errorTooltip="state.inverter.error1"
            :powerValue="state.inverter.power"
            :powerValue2="state.inverter.reactivePower"
            :powerValue3="state.inverter.apparentPower"
            :powerValue4="state.inverter.phase"
            energyText
            energyValue
            :value1Value="state.inverter.u"
            value1Text="V"
            :value2Value="state.inverter.i"
            value2Text="A"
            :value3Value="state.inverter.f"
            value3Text="Hz"
            :value4Text="state.inverter.power > 0 ? $t('home.inverter.desc1') : state.inverter.power < 0 ? $t('home.inverter.desc2') : ''"
            :gaugeColor="gaugeColorInverter"
            :gaugeValue="absInverterPower"
          ></CardUnit>
        </v-col>

        <v-col :cols="$vuetify.breakpoint.md === true ? 12 : ''" :md="$vuetify.breakpoint.md === true ? 6 : ''">
          <CardUnit
            :cardMaxWidth="cardMaxWidth"
            :cardName="$t('home.grid.name')"
            unitName="Grid"
            topRightText="Relay"
            :topRightValue="relayGridConnected"
            :statusValue="statusGrid.toString()"
            :statusText="shortStatusGrid.toString()"
            errorValue
            errorText
            errorTooltip
            :powerValue="state.grid.power"
            :powerValue2="state.grid.reactivePower"
            :powerValue3="state.grid.apparentPower"
            :powerValue4="state.grid.phase"
            :energyHeader1="$t('home.grid.today')"
            :energyHeader2="$t('home.grid.yesterday')"
            :energy1Text="$t('home.grid.produced')"
            :energy1Value="state.grid.energyOverflowsToday"
            :energy2Text="$t('home.grid.consumed')"
            :energy2Value="state.grid.energyConsumptionToday"
            :energy3Text="$t('home.grid.produced')"
            :energy3Value="state.grid.energyOverflowsYesterday"
            :energy4Text="$t('home.grid.consumed')"
            :energy4Value="state.grid.energyConsumptionYesterday"
            :value1Value="state.grid.u"
            value1Text="V"
            :value2Value="state.grid.i"
            value2Text="A"
            :value3Value="state.grid.f"
            value3Text="Hz"
            :value4Text="state.grid.power > 0 ? $t('home.grid.desc1') : state.grid.power < 0 ? $t('home.grid.desc2') : ''"
            :gaugeColor="gaugeColorGrid"
            :gaugeValue="absGridPower"
          ></CardUnit>
        </v-col>

        <v-col :cols="$vuetify.breakpoint.md === true ? 12 : ''" :md="$vuetify.breakpoint.md === true ? 6 : ''">
          <CardUnit
            :cardMaxWidth="cardMaxWidth"
            :cardName="$t('home.battery.name')"
            :event="true"
            unitName="Battery"
            :stateValue="state.battery.state != '' ? $t('variableValues.state.' + state.battery.state.replace('ERR_', '')) : ''"
            :stateText="$t('home.battery.state')"
            :stateTooltip="state.battery.state"
            topRightText="%"
            :topRightValue="soc"
            :statusValue="statusBattery.toString()"
            :statusText="shortStatusBattery.toString()"
            :errorValue="state.battery.error1 != '' ? $t('variableValues.error.' + state.battery.error1) : ''"
            :errorText="$t('home.battery.error')"
            :errorTooltip="state.battery.error1"
            :powerValue="'bat' in state.battery ? state.battery.bat.power : state.battery.power"
            :energyHeader1="$t('home.battery.today')"
            :energyHeader2="$t('home.battery.yesterday')"
            :energy1Text="$t('home.battery.charged')"
            :energy1Value="state.battery.energyChargedToday"
            :energy2Text="$t('home.battery.discharged')"
            :energy2Value="state.battery.energyDischargedToday"
            :energy3Text="$t('home.battery.charged')"
            :energy3Value="state.battery.energyChargedYesterday"
            :energy4Text="$t('home.battery.discharged')"
            :energy4Value="state.battery.energyDischargedYesterday"
            :value1Value="'bat' in state.battery ? state.battery.bat.u : state.battery.u"
            value1Text="V"
            :value2Value="'bat' in state.battery ? state.battery.bat.i : state.battery.i"
            value2Text="A"
            :value3Value="0"
            value3Text
            :value4Text="'bat' in state.battery ? (state.battery.bat.power > 0 ? $t('home.battery.desc1') : state.battery.bat.power < 0 ? $t('home.battery.desc2') : '') : state.battery.power > 0 ? $t('home.battery.desc1') : state.battery.power < 0 ? $t('home.battery.desc2') : ''"
            :gaugeColor="gaugeColorBattery"
            :gaugeValue="absBatteryPower"
          ></CardUnit>
        </v-col>

        <v-col :cols="$vuetify.breakpoint.md === true ? 12 : ''" :md="$vuetify.breakpoint.md === true ? 6 : ''">
          <CardUnit
            :cardMaxWidth="cardMaxWidth"
            :cardName="$t('home.solar.name')"
            :event="true"
            unitName="PV"
            :stateValue="state.pv.state != '' ? $t('variableValues.state.' + state.pv.state.replace('ERR_', '')) : ''"
            :stateText="$t('home.solar.state')"
            :stateTooltip="state.pv.state"
            topRightText
            :topRightValue="solarNReady"
            :statusValue="statusMPPT.toString()"
            :statusText="shortStatusMPPT.toString()"
            :errorValue="state.pv.error1 != '' ? $t('variableValues.error.' + state.pv.error1) : ''"
            :errorText="$t('home.solar.error')"
            :errorTooltip="state.pv.error1"
            :powerValue="state.pv.powerOut"
            :energyHeader1="$t('home.solar.today')"
            :energyHeader2="$t('home.solar.yesterday')"
            :energy1Text="$t('home.solar.produced')"
            :energy1Value="state.pv.energyToday"
            :energy3Text="$t('home.solar.produced')"
            :energy3Value="state.pv.energyYesterday"
            :value1Value="state.pv.uIn"
            value1Text="V"
            :value2Value="state.pv.iIn"
            value2Text="A"
            :value3Value="0"
            value3Text
            :value4Text="state.pv.powerOut > 0 ? $t('home.solar.desc1') : ''"
            :gaugeColor="gaugeColorPV"
            :gaugeValue="state.pv.powerOut"
          ></CardUnit>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-card elevation="10">
            <v-carousel v-model="carousel" cycle interval="60000" :height="carouselHeight" :light="!$vuetify.theme.dark" :dark="$vuetify.theme.dark" :show-arrows="false" delimiter-icon="mdi-circle" hide-delimiter-background>
              <v-carousel-item v-for="(itemCarousel, i) in itemsCarousel" :key="itemCarousel">
                <v-row align="start" justify="center" class="ma-4">
                  <div class="headline">
                    <template v-if="i === 0">
                      {{ $t("home.dashboardChart.pieCharts.name[0]") }}
                    </template>
                    <template v-else-if="i === 1">
                      {{ $t("home.dashboardChart.pieCharts.name[1]") }}
                    </template>
                    <template v-else-if="i === 2">
                      {{ $t("home.dashboardChart.pieCharts.name[2]") }}
                    </template>
                    <template v-else-if="i === 3">
                      {{ $t("home.dashboardChart.pieCharts.name[3]") }}
                    </template>
                    <template v-else-if="i === 4">
                      {{ $t("home.dashboardChart.pieCharts.name[4]") }}
                    </template>
                    <template v-else-if="i === 5">
                      {{ $t("home.dashboardChart.pieCharts.name[5]") }}
                    </template>
                    <template v-else-if="i === 6">
                      {{ $t("home.dashboardChart.pieCharts.name[6]") }}
                    </template>
                    <template v-else-if="i === 7">
                      {{ $t("home.dashboardChart.pieCharts.name[7]") }}
                    </template>
                  </div>
                </v-row>
                <v-row align="center" justify="center" class="ma-8">
                  <OverviewPieCharts :chartType="itemsCarousel[i]" :dataPieCharts="dataPieCharts" />
                </v-row>
              </v-carousel-item>
            </v-carousel>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <AnyChart :heightSheet="365" :heightChart="350" :dark="$vuetify.theme.dark" :tabs="0" :cardHeader="$t('home.dashboardChart.consumptionChart1.name')" :start="''" :stop="''" :ct="'Line'" :card="true" :dashboard="true" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <AnyChart :heightSheet="365" :heightChart="350" :dark="$vuetify.theme.dark" :tabs="1" :cardHeader="$t('home.dashboardChart.consumptionChart2.name')" :start="''" :stop="''" :ct="'Bar'" :card="true" :dashboard="true" />
        </v-col>
        <v-col cols="12" lg="6" md="6">
          <Events :itemsPerPage="5" :height="290" :dashboard="true" />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <AnyChart :heightSheet="365" :heightChart="350" :dark="$vuetify.theme.dark" :tabs="5" :cardHeader="$t('home.dashboardChart.consumptionChart3.name')" :start="''" :stop="''" :ct="'Line'" :card="true" :dashboard="true" />
        </v-col>
      </v-row>

      <Footer :state="state" />
    </template>
    <template v-else>
      <LoadingData />
    </template>

    <UpgradeCore />
  </div>
</template>

<script>
import UpgradeCore from "../../components/upgrade/UpgradeCore.vue";

import AnyChart from "../../components/charts/AnyChart.vue";
import CardUnit from "../../components/cards/CardUnit.vue";
import Events from "./Events.vue";
import Footer from "../../components/Footer.vue";
import LoadingData from "../../components/LoadingData.vue";
import OverviewPieCharts from "../../components/charts/OverviewPieCharts.vue";

import BottomNavigationControl from "../../components/navigation/BottomNavigationControl.vue";

import { mapState } from "vuex";
import { svgGaugeColors } from "../../colors.js";

import * as MyString from "../../serviceapp/string.js";

import { ServiceClient } from "../../service_client/index.js";

export default {
  name: "Home",
  components: {
    AnyChart,
    BottomNavigationControl,
    CardUnit,
    Events,
    Footer,
    OverviewPieCharts,
    LoadingData,
    UpgradeCore,
  },

  data() {
    return {
      user: JSON.parse(sessionStorage.getItem("user")),

      task: 0,
      timer: null,

      carouselHeight: 430,

      soc: 0,

      hdo: false,

      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      cardMaxWidth: 500,

      mobile: false,

      absGridPower: 0,
      absInverterPower: 0,
      absBatteryPower: 0,

      relayGridConnected: 0,
      relayInverterConnected: 0,
      solarNReady: 0,

      carousel: 0,

      itemsCarousel: [
        "Current",
        "Today",
        "Today2",
        "Yesterday",
        "Yesterday2",
        /*
        "Weekly",
        "Monthly",
        "Yearly"
        */
      ],

      gaugeColorLoad: [
        { offset: 0, color: svgGaugeColors.load[0] },
        { offset: 100, color: svgGaugeColors.load[1] },
      ],
      gaugeColorBattery: [
        { offset: 0, color: svgGaugeColors.battery[0] },
        { offset: 100, color: svgGaugeColors.battery[1] },
      ],
      gaugeColorInverter: [
        { offset: 0, color: svgGaugeColors.inverter[0] },
        { offset: 100, color: svgGaugeColors.inverter[1] },
      ],
      gaugeColorGrid: [
        { offset: 0, color: svgGaugeColors.grid[0] },
        { offset: 100, color: svgGaugeColors.grid[1] },
      ],
      gaugeColorPV: [
        { offset: 0, color: svgGaugeColors.pv[0] },
        { offset: 100, color: svgGaugeColors.pv[1] },
      ],

      statusInverter: "",
      statusBattery: "",
      statusGrid: "",
      statusMPPT: "",
      statusConsumption: "",

      shortStatusLen: 45, // 85,

      shortStatusInverter: "",
      shortStatusBattery: "",
      shortStatusGrid: "",
      shortStatusMPPT: "",
      shortStatusConsumption: "",

      state: null,
      dataPieCharts: null,
      dataPPDS: null,
    };
  },
  computed: {
    ...mapState({
      device: (state) => state.device,
    }),
  },
  methods: {
    createInverterStateDescription(array, object, phase) {
      let decs = this.$t("basic.phase") + " " + phase + ": ";

      if (object.u8GridOnly === 1) {
        if (object.u8OutputDisabledLowBattery === 1) {
          array.push(decs + this.$t("home.status.inverter.standbyBattery"));
        } else if (object.u8OutputDisabledMinimalConsumption === 1) {
          array.push(decs + this.$t("home.status.inverter.standbyConsumption"));
        }
      } else {
        if (object.u8Sharing === 1) {
          array.push(decs + this.$t("home.status.inverter.generating"));
        } else if (object.u8Charging === 1) {
          array.push(decs + this.$t("home.status.inverter.charging"));
        }
      }

      return array;
    },
    getData(json) {
      ServiceClient.dataCore(ServiceClient.getAPIUrl(json), null, null, "GET")
        .then((data) => {
          if (json == "main") {
            this.state = data;

            this.absGridPower = Math.abs(this.state.grid.power);
            this.absInverterPower = Math.abs(this.state.inverter.power);

            if ("bat" in this.state.battery) {
              this.absBatteryPower = Math.abs(this.state.battery.bat.power);
            } else {
              this.absBatteryPower = Math.abs(this.state.battery.power);
            }

            var re1a = /Relay Inv DC/gi;
            var re1b = /InverterRelayDisconnected/gi;
            var re1c = /RelayInvDisc/gi;

            var re2a = /Relay Grid DC/gi;
            var re2b = /GridRelayDisconnected/gi;
            var re2c = /RelayGridDisc/gi;

            var re3 = /SolarsReady/gi;

            var re4 = /HDO/gi;

            // Old Version - Compability
            if ("energyControlStatus1" in this.state.inverter) {
              if (this.state.inverter.energyControlStatus1.search(re4) == -1) {
                this.hdo = 0;
              } else {
                this.hdo = 1;
              }
              if (this.state.inverter.energyControlStatus1.search(re1a) != -1 || this.state.inverter.energyControlStatus1.search(re1b) != -1 || this.state.inverter.energyControlStatus1.search(re1c) != -1) {
                this.relayInverterConnected = 0;
              } else {
                this.relayInverterConnected = 1;
              }
            }
            if ("energyControlStatus1" in this.state.grid) {
              if (this.state.grid.energyControlStatus1.search(re2a) != -1 || this.state.grid.energyControlStatus1.search(re2b) != -1 || this.state.grid.energyControlStatus1.search(re2c) != -1) {
                this.relayGridConnected = 0;
              } else {
                this.relayGridConnected = 1;
              }
            }

            // New Version
            if ("ecStatus1" in this.state.inverter) {
              if (this.state.inverter.ecStatus1.search(re4) == -1) {
                this.hdo = 0;
              } else {
                this.hdo = 1;
              }
              if (this.state.inverter.ecStatus1.search(re1a) != -1 || this.state.inverter.ecStatus1.search(re1b) != -1 || this.state.inverter.ecStatus1.search(re1c) != -1) {
                this.relayInverterConnected = 0;
              } else {
                this.relayInverterConnected = 1;
              }
              if (this.state.inverter.ecStatus1.search(re2a) != -1 || this.state.inverter.ecStatus1.search(re2b) != -1 || this.state.inverter.ecStatus1.search(re2c) != -1) {
                this.relayGridConnected = 0;
              } else {
                this.relayGridConnected = 1;
              }
            }

            if (this.state.pv.status.search(re3) == -1) {
              this.solarNReady = 1;
            } else {
              this.solarNReady = 0;
            }

            let averageSOC = 0;
            let batteryOnline = 0;

            for (let index = 0; index < this.state.battery.batteries.length; index++) {
              if (this.state.battery.batteries[index].state != "Reset") {
                averageSOC += this.state.battery.batteries[index].bms.soc;
                batteryOnline++;
              }
            }
            if (batteryOnline != 0) {
              averageSOC /= batteryOnline;
            }
            this.soc = averageSOC;

            let limitIpos = 0;
            let limitIneg = 0;
            let limitPpos = 0;
            let limitPneg = 0;

            for (let index = 0; index < this.state.battery.batteries.length; index++) {
              if ("batteries" in this.state.battery) {
                if (
                  this.state.battery.batteries[index].state == "ON" ||
                  this.state.battery.batteries[index].state == "Start" ||
                  this.state.battery.batteries[index].state == "Stop" ||
                  this.state.battery.batteries[index].state == "StandBy" ||
                  this.state.battery.batteries[index].state == "OFF_WaitForSOCIncreasing"
                ) {
                  if ("limitIpos" in this.state.battery.batteries[index]) limitIpos += this.state.battery.batteries[index].limitIpos;
                  if ("limitIneg" in this.state.battery.batteries[index]) limitIneg += this.state.battery.batteries[index].limitIneg;
                  if ("limitPpos" in this.state.battery.batteries[index]) limitPpos += this.state.battery.batteries[index].limitPpos;
                  if ("limitPneg" in this.state.battery.batteries[index]) limitPneg += this.state.battery.batteries[index].limitPneg;
                }
              }
            }

            this.statusBattery = [];

            this.statusBattery.push(this.$t("home.status.battery.chargingCurrent") + ": " + limitIneg.toFixed(2) + "A");
            this.statusBattery.push(this.$t("home.status.battery.disChargingCurrent") + ": " + limitIpos.toFixed(2) + "A");
            this.statusBattery.push(this.$t("home.status.battery.chargingPower") + ": " + limitPneg.toFixed(2) + "kW");
            this.statusBattery.push(this.$t("home.status.battery.disChargingPower") + ": " + limitPpos.toFixed(2) + "kW");

            this.statusBattery = MyString.ArrayToStringAndAddVerticalBarBetweenIndexes(this.statusBattery);
            this.shortStatusBattery = MyString.MakeShortVersionFromLongString(this.statusBattery, this.shortStatusLen);
          } else if (json == "chartpies") {
            this.dataPieCharts = data;
          } else if (json == "ppds") {
            this.dataPPDS = data;

            this.statusInverter = [];
            this.statusGrid = [];
            this.statusMPPT = [];
            this.statusMPPT = "";
            this.shortStatusMPPT = "";

            if (this.hdo === 1) {
              this.statusInverter.push("HDO = 1");
            } else {
              this.statusInverter.push("HDO = 0");
            }

            for (let index = 0; index < this.dataPPDS.state.length; index++) {
              this.statusInverter = this.createInverterStateDescription(this.statusInverter, this.dataPPDS.state[index], index + 1);
            }

            let fP = 0;
            let fPfSOC = 0;
            for (let index = 0; index < this.dataPPDS.PLimits.length; index++) {
              fP += this.dataPPDS.PLimits[index].fP;
              fPfSOC += this.dataPPDS.PLimits[index].fPfSOC;
            }

            this.statusInverter.push(this.$t("home.status.inverter.maxPower") + ": " + Math.round((fP / 1000) * 100) / 100 + " kW ");
            this.statusInverter.push(this.$t("home.status.inverter.batPower") + ": " + Math.round((fPfSOC / 1000) * 100) / 100 + " kW ");

            if (this.dataPPDS.ppds[0].u8InterfaceProtectionTripped === 1) {
              this.statusGrid.push(this.$t("home.status.grid.interfaceProtectionTripped"));
            } else {
              this.statusGrid.push(this.$t("home.status.grid.interfaceProtectionNotTripped"));
            }

            if (this.dataPPDS.ppds[0].u8GridPresent === 1) {
              this.statusGrid.push(this.$t("home.status.grid.present"));
            } else {
              this.statusGrid.push(this.$t("home.status.grid.notPresent"));
            }

            if (this.dataPPDS.ppds[0].u8GridConnected === 1) {
              this.statusGrid.push(this.$t("home.status.grid.connected"));
            } else {
              this.statusGrid.push(this.$t("home.status.grid.notConnected"));
            }

            if (this.dataPPDS.ppds[0].u8GeneratingAndChargingEnabled === 1) {
              this.statusGrid.push(this.$t("home.status.grid.generatingAndChargingEN"));
            } else {
              this.statusGrid.push(this.$t("home.status.grid.generatingAndChargingDIS"));
            }

            this.statusConsumption = "";
            this.shortStatusConsumption = "";

            this.statusInverter = MyString.ArrayToStringAndAddVerticalBarBetweenIndexes(this.statusInverter);
            this.shortStatusInverter = MyString.MakeShortVersionFromLongString(this.statusInverter, this.shortStatusLen);

            this.statusGrid = MyString.ArrayToStringAndAddVerticalBarBetweenIndexes(this.statusGrid);
            this.shortStatusGrid = MyString.MakeShortVersionFromLongString(this.statusGrid, this.shortStatusLen);

            this.shortStatusInverter = MyString.InsertSpaces(this.shortStatusInverter, this.shortStatusLen);
            this.statusInverter = MyString.InsertSpaces(this.statusInverter, this.shortStatusLen);

            this.shortStatusGrid = MyString.InsertSpaces(this.shortStatusGrid, this.shortStatusLen);
            this.statusGrid = MyString.InsertSpaces(this.statusGrid, this.shortStatusLen);

            this.shortStatusConsumption = MyString.InsertSpaces(this.shortStatusConsumption, this.shortStatusLen);
            this.statusConsumption = MyString.InsertSpaces(this.statusConsumption, this.shortStatusLen);

            this.shortStatusMPPT = MyString.InsertSpaces(this.shortStatusMPPT, this.shortStatusLen);
            this.statusMPPT = MyString.InsertSpaces(this.statusMPPT, this.shortStatusLen);
          }
        })
        .catch((error) => {
          if (json == "main") {
            this.state = ServiceClient.handleUnauthorized(error, this.$router);
          } else if (json == "chartpies") {
            this.dataPieCharts = ServiceClient.handleUnauthorized(error, this.$router);
          } else if (json == "ppds") {
            this.dataPPDS = ServiceClient.handleUnauthorized(error, this.$router);
          }
        });
    },
    pollData() {
      this.timer = setInterval(() => {
        switch (this.task) {
          case 1:
            this.getData("main");
            break;
          case 2:
            this.getData("ppds");
            break;
          case 3:
            this.getData("main");
            break;
          case 4:
            this.getData("chartpies");
            break;
          case 5:
            this.getData("ppds");
            break;
          default:
            this.task = 0;
            break;
        }

        this.task++;
      }, 1250);
    },
    onResize() {
      this.getBreakpoints();
    },
    getBreakpoints() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;

      if (this.windowWidth < 768) {
        this.carouselHeight = 860;
        this.cardMaxWidth = this.windowWidth;
        this.mobile = true;
      } else {
        this.carouselHeight = 430;
        this.cardMaxWidth = 1200;
        this.mobile = false;
      }

      /*       
      <959 -> 1
      960 -  1262 -> 2
      1264 -> 5 
      */

      let coef = 1;
      if (this.windowWidth >= 1264) {
        coef = 5;
      } else if (this.windowWidth >= 960) {
        coef = 2;
      } else {
        coef = 1;
      }

      this.shortStatusLen = this.windowWidth / coef / 8;
      /* this.shortStatusLen = (this.windowWidth / coef)/ 20; */

      /* console.log(this.windowWidth / coef); */
      /* windowWidth */
    },
  },
  created() {
    this.getBreakpoints();

    setTimeout(() => {
      this.getData("main");
    }, 0);
    setTimeout(() => {
      this.getData("chartpies");
    }, 500);
    setTimeout(() => {
      this.getData("ppds");
    }, 1000);
  },
  mounted() {
    this.pollData();

    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy: function () {
    clearInterval(this.timer);

    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style scoped></style>
